import API from "../../api/api";
import { authHeaderWithImage } from "../../helpers/authHeader";
const state = () => ({
  researchDevelopemntObj: null,
  loading: false,
});

const mutations = {
  getResearchDevelopmentDetail(state, payload) {
    state.researchDevelopemntObj = payload;
  },
  addResearchDevelopment(state, payload) {
    state.researchDevelopemntObj = payload;
  },
  editResearchDevelopment(state, payload) {
    // const index = state.models.findIndex((m) => m.id === payload.id);
    // if (index) {
    state.researchDevelopemntObj = payload;
    // }
  },
  setDetailInput: (state, e) => {
    let researchDevelopemntObj = state.researchDevelopemntObj;
    researchDevelopemntObj[e.target.name] = e.target.value;
    state.researchDevelopemntObj = researchDevelopemntObj;
  },
  isLoading(state, payload) {
    state.loading = payload;
  },
};

const actions = {
  async fetchResearchDevelopmentDetail({ commit }, payload) {
    commit("isLoading", true);
    await API.get(`research-and-development/${payload}`)
      .then(res => {
        commit("getResearchDevelopmentDetail", res.data.data);
        commit("isLoading", false);
      })
      .catch(err => {
        console.log("ERROR", err);
        commit("isLoading", false);
      });
  },
  async post({ commit }, payload) {
    await API.post("research-and-development", payload, {
      headers: authHeaderWithImage(),
    })
      .then(res => {
        commit("addResearchDevelopment", res.data.data);
      })
      .catch(err => {
        console.log("ERROR", err);
      });
  },
  async put({ commit }, payload) {
    await API.put(`research-and-development/1`, payload, {
      headers: authHeaderWithImage(),
    })
      .then(res => {
        if (res) {
          commit("editResearchDevelopment", res.data.data);
        }
      })
      .catch(err => {
        console.log("ERROR", err);
      });
  },
  updateInput({ commit }, e) {
    commit("setDetailInput", e);
  },
};

const getters = {
  researchDevelopemntObj: state => state.researchDevelopemntObj,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
